module.exports = require("@swa-ui/core/src/Card/Tile/Tile.module.scss");